import { Component, OnInit, Inject } from '@angular/core';
import { DataService } from '../data.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-pres-conceptos-edit',
  templateUrl: './pres-conceptos-edit.component.html',
  styleUrls: ['./pres-conceptos-edit.component.css']
})
export class PresConceptosEditComponent implements OnInit {
  errMsg:any;
  okMsg:any;
  loading:boolean=false;
  tiempoMsg:number=3200;
  activo:boolean;
  esNuevo:boolean;
  resultado:any=[];
  esDuplicado: boolean = false;
  thisForm = new FormGroup({
    concep: new FormControl(this.data.item.concepto, [Validators.required, Validators.minLength(3)]),
    etiq: new FormControl(this.data.nivel == 1 ? this.data.item.lblConcepto : (this.data.nivel == 2 ? this.data.item.lblSubconcepto : this.data.item.detalle), []),
    nota: new FormControl(this.data.item.nota, []),
    preCarga: new FormControl(this.data.item.preCarga, []),
  });

  constructor(private dataService: DataService, public dialogRef: MatDialogRef<PresConceptosEditComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    console.log(this.data);
    if(this.data){
      if(this.data.id > 0)
        this.esNuevo=false;
      else
        this.esNuevo=true;
      if(this.data.nivel == 1)
        this.activo = this.data.item.actN1;
      if(this.data.nivel == 2)
        this.activo = this.data.item.actN2;
      if(this.data.nivel == 3)
        this.activo = this.data.item.actN3;
    }
  }
  
  fnKeyPress(t, e){
    this.errMsg="";
    if (!this.dataService.validKey(t,e)){
        this.errMsg="Caracter inválido!";
        setTimeout(() => {
            this.errMsg="";
        }, this.tiempoMsg);
        return false;
    }
    else
      return true;
  }

  fnKeyUp(t, e){
    //console.log(e);
  }

  onBlur(event){
    this.dataService.isConceptoDup(this.thisForm.controls["concep"].value).subscribe(
                          rows => {   
                                  this.resultado = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnConceptoDuplicado());
  }

  fnConceptoDuplicado(){
    this.esDuplicado = false;
    if(this.resultado > 0){
      this.fnMuestraMensaje("ERR", "El concepto ya ha sido dada de alta; revise su información.", false, false);
      this.thisForm.controls["concep"].markAsDirty();
      var aux = <HTMLInputElement>document.getElementById("txtConcepto");
      this.esDuplicado=true;
      aux.focus();
    }
  }

  fnMuestraMensaje(tipo:string, msg:string, changeLoading:boolean, closeDialog:boolean){
    this.okMsg = "";
    this.errMsg = "";
    if(tipo=="OK")
      this.okMsg = msg;
    if(tipo=="ERR")
      this.errMsg = msg;
    setTimeout(() => {
      this.okMsg = "";
      this.errMsg = "";
      if(changeLoading)
        this.loading = !this.loading;
      if(closeDialog)
        this.dialogRef.close();
    }, this.tiempoMsg);
  }

  fnDesactivar(){
    this.activo = false;
  }

  fnActivar(){
    this.activo = true;
  }

  fnClickPreCarga(item){
    setTimeout(() => {
      console.log("PRECARGA: " + item.checked);      
    }, 20);
  }

  fnGuardar(){
    this.loading = true;
    var preCarga = 'NO';
    if(this.esNuevo){
      //console.log("GUARDAR");
      //--> Forma con nombre y mínimo 3 caracteres:
      if(this.thisForm.valid)
        this.dataService.insConcepto(this.data.niv, this.activo, this.thisForm.controls["concep"].value, this.thisForm.controls["etiq"].value, this.thisForm.controls["descr"].value, preCarga).subscribe(
                        rows => {   
                                this.resultado = <any>rows
                                },          
                        error => this.errMsg = <any>error,
                        () => this.fnConceptoGuardado());    
       
       else{
        //console.log(this.thisForm.controls["forma"].errors);
        if(this.thisForm.controls["concep"].errors.required)
          this.fnMuestraMensaje("ERR", "Capture una 'Concepto'.", true, false)
        if(this.thisForm.controls["concep"].errors.minlength){
          //console.log(this.thisForm.controls["forma"].errors.minlength.actualLength);
          if(this.thisForm.controls["concep"].errors.minlength.actualLength < this.thisForm.controls["concep"].errors.minlength.requiredLength)
            this.fnMuestraMensaje("ERR", "El 'concepto' debe contener " + this.thisForm.controls["concep"].errors.minlength.requiredLength + " o más caracteres.", true, false)
        }
      }               
    }
    else{
      //console.log("EDITAR");
      //--> Nada que validar
      this.dataService.updConcepto(this.data.nivel, this.data.id, this.activo, this.thisForm.controls["concep"].value, this.thisForm.controls["etiq"].value, this.thisForm.controls["nota"].value, preCarga).subscribe(
                        rows => {    
                                this.resultado = <any>rows
                                },          
                        error => this.errMsg = <any>error,
                        () => this.fnConceptoEditado());    
    }
  }

  fnConceptoGuardado(){
    console.log(this.resultado);
    if(this.resultado == 1){
      this.fnMuestraMensaje("OK", "Registro almacenado", false, true);
    }
    else{
      this.fnMuestraMensaje("ERR", "Error al almacenar registro", true, false);
      setTimeout(() => {
        this.loading = false;
      }, this.tiempoMsg);
    }
  }  

  fnConceptoEditado(){
    console.log(this.resultado);
    if(this.resultado == 1){
      this.okMsg = "Registro actualizado"
      setTimeout(() => {
        this.okMsg = "";
        this.loading = false;
        this.dialogRef.close();
      }, this.tiempoMsg);
    }
    else{
      this.errMsg = "Error al actualizar registro!"
      setTimeout(() => {
        this.errMsg = "";
        this.loading = false;
      }, this.tiempoMsg);
    }
  }

}
